import styled from 'styled-components';

export const Container = styled.div``;

export const TitleAcess = styled.p`
  text-align: center;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #2e384d;
  opacity: 1;
  margin: 70px 0;

  @media (max-width: 759px) {
    padding: 0 20px;
    margin: 48px 0;
  }
`;
